import { atom } from "jotai";

export const soundPopState = atom({
  open: false,
  category: "",
  categoryKey: "",
  title: "",
  grade: "",
  url: "",
  songTitle: "",
  caption: "",
});

export const bookInfoPopState = atom({
  open: false,
  category: "",
  categoryKey: "",
  title: "",
  badge: "",
  cover: "",
  background: "",
  song: "",
  mov: "",
  activity: "",
});

export const wordPopState = atom({
  open: false,
  mode: "word",
  data: [],
  data2: [],
});

export const activityPopState = atom({
  open: false,
  questions: [],
});

export const gamePopState = atom({
  open: false,
  isPlay: false,
  type: "",
  categoryKey: "",
  data: null,
});

// export const gamePopState = atom({
//   open: true,
//   isPlay: true,
//   type: "donut",
//   data: {
//     resources: [
//       {
//         img: require("@data/assets/red/book2/images/img_R2-01.png"),
//         sound: require("@data/assets/red/book2/sounds/KA02_W_01_말.mp3"),
//         word: "mǎ",
//       },
//       {
//         img: require("@data/assets/red/book2/images/img_R2-02.png"),
//         sound: require("@data/assets/red/book2/sounds/KA02_W_02_공룡.mp3"),
//         word: "kǒnglóng",
//       },
//       {
//         img: require("@data/assets/red/book2/images/img_R2-03.png"),
//         sound: require("@data/assets/red/book2/sounds/KA02_W_03_학.mp3"),
//         word: "hè",
//       },
//       {
//         img: require("@data/assets/red/book2/images/img_R2-04.png"),
//         sound: require("@data/assets/red/book2/sounds/KA02_W_04_개구리.mp3"),
//         word: "qīngwā",
//       },
//       {
//         img: require("@data/assets/red/book2/images/img_R2-05.png"),
//         sound: require("@data/assets/red/book2/sounds/KA02_W_05_사슴.mp3"),
//         word: "lù",
//       },
//       {
//         img: require("@data/assets/red/book2/images/img_R2-06.png"),
//         sound: require("@data/assets/red/book2/sounds/KA02_W_06_당나귀.mp3"),
//         word: "lǘ",
//       },
//     ],
//   },
// });

export const bookSoundPlayerState = atom({
  open: false,
  url: require("@data/assets/red/book1/sounds/page04.mp3"),
});

export const zoomViewState = atom({
  open: false,
  page: 0,
  pages: [],
});
